<!-- skeleton/app/src/app/app.component.html -->

<div (mousemove)="resetIdleTimer()" (keypress)="resetIdleTimer()">

  <app-header-component *ngIf="isHeaderShow"></app-header-component>

  <!-- Authenticated layout (this component already contains its own router-outlet) -->
  <app-menu-navbar *ngIf="isHeaderShow"></app-menu-navbar>

  <!-- Public routes (login/forgot/etc) must still render somewhere -->
  <router-outlet *ngIf="!isHeaderShow"></router-outlet>

  <ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" [fullScreen]="true" type="ball-clip-rotate" color="transparent">
    <svg class="custom-spinner" viewBox="0 0 50 50">
      <circle class="spinner-circle" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
    </svg>
  </ngx-spinner>

</div>
